import Dexie from 'dexie';

export const LoginTelegramDB = new Dexie('LoginTelegramDB');

LoginTelegramDB.version(1).stores({
    Data: `++id,
    Session,
    PhoneNumber,
    User,
    ProfilePhoto,
    BotSession,
    ListForJoin,
    CountryName,
    CountryNameIso,
    MyClient,
    FirstTime`
});
